import request from '@/config/axios'

/** 红包活动规则。金额单位为分；时间为空表示不限，非空按上海时间传输。 */
export interface RedPacketRule {
  enabled: boolean
  minFen: number
  maxFen: number
  dailyLimit: number
  totalLimit: number
  dailyStock: number
  startTime: string | null
  endTime: string | null
  title: string
  subtitleTemplate: string
  description: string
  validityText: string
  claimText: string
  claimingText: string
  balanceNote: string
  currencySymbol: string
  openingText: string
  stockTemplate: string
  unlimitedStockText: string
  footerText: string
  successTitle: string
  successDescription: string
  balanceLabel: string
  successButtonText: string
  closedMessage: string
  soldOutMessage: string
  limitMessage: string
}

export const getRedPacketRule = () =>
  request.get<RedPacketRule>({ url: '/bosscircle/red-packet/get' })

export const updateRedPacketRule = (data: RedPacketRule) =>
  request.post({ url: '/bosscircle/red-packet/save', data })

export const resetRedPacketRule = () => request.delete({ url: '/bosscircle/red-packet/reset' })
